import request from 'superagent';

/**
 * The shared, credentialed superagent instance used for all authenticated API
 * requests.
 *
 * This lives in its own leaf module (rather than `authentication/index.js`) so
 * that low-level consumers — e.g. `mandark.resource` and the Intercom service —
 * can grab the agent without importing the full authentication module, which in
 * turn imports `IntercomService` and the session lifecycle. Importing those
 * would re-form a runtime import cycle (TDZ risk under ESM/SWC).
 */
const agent = request.agent().withCredentials();

export function getRequestAgent() {
  return agent;
}
